<template>
  <div>
    <div :class="[$style.field, 'mb-3']">
      <div :class="$style.field_label">
        {{ locales('settings_task_name') }}
      </div>
      <vgp-dropdown-select
        :drop-list="taskNameDisplayOptions"
        :multiselect="false"
        :selected="selectedTaskNameDisplay"
        :show-reset-btn="false"
        track-by-text="label"
        :show-selected-first="false"
        @selected="handleSelectTaskNameDisplay"
      />
    </div>
    <div :class="$style.toggles_wrapper">
      <div
        v-for="option in options"
        :key="option.id"
        :class="$style.toggle_row"
      >
        <div :class="$style.toggle_label">
          {{ option.label }}
        </div>
        <vgp-toggle
          :is-toggle-on="option.isToggled"
          @onChange="handleToggleOption(option)"
        />
      </div>
    </div>
  </div>
</template>

<script>

import VgpToggle from '$$vueCmp/checkbox/squareToggle.vue';
import VgpDropdownSelect from '$$vueCmp/dropdownSelect/dropdownSelect.vue';
import rights from '../../../components/rights';
import pricingHelper from '../../../helpers/pricingHelper';

const TASK_NAME_DISPLAY_CONFIG_KEY = 'right_side_text';

export default {
  name: 'ConfigSettings',
  components: {
    VgpToggle,
    VgpDropdownSelect,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  emits: [
    'option-change',
  ],
  data() {
    return {
      selectedTaskNameDisplay: null,
      taskNameDisplayOptions: [
        { id: 'insideText', label: __('export_setting_inside_text') },
        { id: 'rightSideText', label: __('export_setting_right_side_text') },
        { id: 'noTaskText', label: __('export_setting_no_task_text') },
      ],
      toggleOptions: [
        {
          id: 'cross_out_tasks',
          label: __('export_cross_out_tasks'),
          isToggled: !!this.config.cross_out_tasks,
        },
        {
          id: 'discoloration_tasks',
          label: __('export_discoloration_tasks'),
          isToggled: !!this.config.discoloration_tasks,
        },
        {
          id: 'highlight_critical_path',
          label: __('export_critical_way'),
          isToggled: !!this.config.highlight_critical_path,
        },
        {
          id: 'current_day_marker',
          label: __('export_current_day_marker'),
          isToggled: !!this.config.current_day_marker,
        },
        {
          id: 'hide_workload',
          label: __('export_workload'),
          isToggled: !this.config.hide_workload,
          hide: !rights.project.hasRight(this.config.gantt_id, 'workload'),
        },
        {
          id: 'highlight_overdue',
          label: __('export_highlight_overdue'),
          isToggled: !!this.config.highlight_overdue,
        },
      ],
    };
  },
  computed: {
    locales() {
      return __;
    },
    options() {
      const accessOverdueTasks = pricingHelper.checkPricingAccess('overdue_tasks');
      let options = this.toggleOptions;

      if (!accessOverdueTasks) {
        options = options.filter(option => option.id !== 'highlight_overdue');
      }

      return options.filter(opt => !opt.hide);
    },
  },
  created() {
    this.setInitialSelectedTaskNameDisplay();
  },
  methods: {
    setInitialSelectedTaskNameDisplay() {
      this.selectedTaskNameDisplay = this.taskNameDisplayOptions.find(option => option.id === this.config[TASK_NAME_DISPLAY_CONFIG_KEY]);
    },
    handleSelectTaskNameDisplay(selected) {
      const [selectedItem] = selected;

      this.$emit('option-change', { id: TASK_NAME_DISPLAY_CONFIG_KEY, value: selectedItem.id });
    },
    handleToggleOption(option) {
      option.isToggled = !option.isToggled;
      this.$emit('option-change', { id: option.id, value: option.isToggled });
    },

  },
};
</script>

<style module lang="less">
.field {
    display: flex;
    flex-direction: column;
    margin: 0 12px 12px;
    &_label {
        font-size: 12px;
        line-height: 18px; /* 150% */
        color: #999999;
        font-family: "Lato-Bold", sans-serif;
        margin-bottom: 4px;
    }
}

.toggles_wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
    margin: 0 12px;
}

.toggle_label {
  font-size: 14px;
  line-height: 20px;
  color: #191919;
  font-family: Lato-Regular, sans-serif;
}

.toggle_row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 4px 0;
}

.toggle_divider {
  height: 1px;
  background: #E6E6E6;
  flex: 1;
  margin: 0 12px;
}
</style>
